// Convert snake_case to camelCase
const snakeToCamel = str => {
    return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

// Convert object keys from snake_case to camelCase (recursive)
const convertSnakeToCamel = obj => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => convertSnakeToCamel(item));
    }

    const converted = {};
    for (const [key, value] of Object.entries(obj)) {
        const camelKey = snakeToCamel(key);
        converted[camelKey] = convertSnakeToCamel(value);
    }
    return converted;
};

// Convert camelCase to snake_case (reverse function)
const camelToSnake = str => {
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};

// Convert object keys from camelCase to snake_case (recursive)
const convertCamelToSnake = obj => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => convertCamelToSnake(item));
    }

    const converted = {};
    for (const [key, value] of Object.entries(obj)) {
        const snakeKey = camelToSnake(key);
        converted[snakeKey] = convertCamelToSnake(value);
    }
    return converted;
};

// Built-in function using modern JavaScript (ES2022+)
const snakeToCamelBuiltIn = str => {
    return str.replaceAll(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export { snakeToCamel, convertSnakeToCamel, camelToSnake, convertCamelToSnake, snakeToCamelBuiltIn };
